module.exports = __webpack_public_path__ + "img/service_img01.e8e6cac4.png";